import React from 'react';
import styles from './ManageFulfillmentSKU.module.scss';
import { Button, Col, Row } from 'reactstrap';
import { utils, writeFile } from 'xlsx';
import ManageTable from '../../../../Manage/ManageTable';

const data = [
  {
    id: 1,
    fulfillmentSku: '65386249',
    sellerSku: 'voilet89a',
    platformSku: '367658',
    barcode: '367658',
    shelfLife: '1 year',
    serialNo: '235345',
    stock: '500',
    minStockAlert: '20',
  },
  {
    id: 2,
    fulfillmentSku: '65386249',
    sellerSku: 'voilet89a',
    platformSku: '367658',
    barcode: '367658',
    shelfLife: '1 year',
    serialNo: '235345',
    stock: '500',
    minStockAlert: '20',
  },
  {
    id: 3,
    fulfillmentSku: '65386249',
    sellerSku: 'voilet89a',
    platformSku: '367658',
    barcode: '367658',
    shelfLife: '1 year',
    serialNo: '235345',
    stock: '500',
    minStockAlert: '20',
  },
  {
    id: 4,
    fulfillmentSku: '65386249',
    sellerSku: 'voilet89a',
    platformSku: '367658',
    barcode: '367658',
    shelfLife: '1 year',
    serialNo: '235345',
    stock: '500',
    minStockAlert: '20',
  },
];

const columns = [
  {
    name: 'Fulfillment SKU',
    selector: (row) => row.fulfillmentSku,
    sortable: true,
    minWidth: "150px",
  },
  {
    name: 'Seller SKU',
    selector: (row) => row.sellerSku,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Platform SKU',
    selector: (row) => row.platformSku,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Barcode',
    selector: (row) => row.barcode,
    sortable: true,
    minWidth: "120px",
  },
  {
    name: 'Shelf Life',
    selector: (row) => row.shelfLife,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Serial no.',
    selector: (row) => row.serialNo,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: 'Stock',
    selector: (row) => row.stock,
  },
  {
    name: 'Min. Stock Alert',
    selector: (row) => row.minStockAlert,
    minWidth: "140px",
  },
  {
    name: 'Action',
  },
];

const ManageFulfillmentSKU = () => {

  const handlePrint = () => {
    window.print();
  };

  const handleExportExcel = () => {
    const worksheet = utils.json_to_sheet(data);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Products');
    writeFile(workbook, 'ManagePlatformProducts.xlsx');
  };

  return (
    <div className={styles.mainManageProductsContainer}>
      <h4 className={styles.sectionHeading}>Manage Fulfillment SKU</h4>

      <div className={styles.manageProducts}>

        <Row className={styles.totalProducts}>
          <Col lg={"auto"} className={styles.totalProductsContainer}>
            <span>Total Products: 200</span>
          </Col>
          <Col lg={"auto"} className={styles.btnsContainer}>
            <Button type="button" onClick={handlePrint}>
              Print
            </Button>
            <Button type="button" onClick={handleExportExcel}>
              Export
            </Button>
          </Col>
        </Row>

        <ManageTable 
          name={'Manage Fulfillment SKU'}
          columns={columns}
          tableData={data}
          isSelectable={true}
        />
      </div>
    </div>
  )
}

export default ManageFulfillmentSKU;